/* ── DY Cart Drawer ─────────────────────────────────────────── */
(function () {
  'use strict';

  /* Handles of the three individual DY flavors.
     IDs are fetched dynamically from Shopify — never hard-coded. */
  var DY_HANDLES = ['boost', 'chill', 'gut'];

  /* Module state */
  var _productCache = {};
  var _overlay, _drawer, _addedEl, _meetEl, _subtotalEl;
  var _isInit = false;

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    if (_isInit) return;
    _isInit = true;

    _overlay    = document.getElementById('dy-cd-overlay');
    _drawer     = document.getElementById('dy-cd-drawer');
    _addedEl    = document.getElementById('dy-cd-added');
    _meetEl     = document.getElementById('dy-cd-meet-products');
    _subtotalEl = document.getElementById('dy-cd-subtotal');

    if (!_drawer) return;

    /* Close handlers */
    _overlay.addEventListener('click', closeDrawer);
    var closeBtn = _drawer.querySelector('.dy-cd__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && _drawer.classList.contains('is-open')) closeDrawer();
    });

    /* Intercept every /cart/add form submission */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var idInput  = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput) return;
      var variantId = parseInt(idInput.value, 10);
      var qty       = parseInt((qtyInput && qtyInput.value) || 1, 10);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
      addToCartAndOpen(variantId, qty, submitBtn);
    });

    /* Quick-add button clicks — works in drawer, cart page, AND product cards.
       e.stopPropagation() prevents anchor navigation when button is inside <a>. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dy-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(btn.dataset.dyQuickAdd, 10);
      if (!variantId) return;
      var fromOutsideDrawer = !btn.closest('#dy-cd-drawer');
      btn.disabled = true;
      btn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (lineItem) {
        return fetchCart().then(function (cart) { return [lineItem, cart]; });
      })
      .then(function (result) {
        var lineItem = result[0], cart = result[1];
        if (fromOutsideDrawer) {
          /* Card quick-add: render drawer with just-added item and open it */
          renderDrawer(lineItem, cart);
          openDrawer();
        } else {
          /* Already inside drawer: refresh cross-sell without re-rendering the item */
          updateSubtotal(cart);
          updateCartCount(cart.item_count);
          if (_meetEl) renderMeet(getCartHandles(cart), _meetEl, 'drawer');
          var cpEl = document.getElementById('dy-cp-meet-products');
          if (cpEl) renderMeet(getCartHandles(cart), cpEl, 'cart');
        }
        btn.textContent = '✓ Added';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ ADD';
      });
    });

    /* Variant selector change → keep form hidden-id in sync */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('.dy-pdp__variant-select');
      if (!sel) return;
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var hiddenId = form.querySelector('[name="id"]');
      var atbBtn   = form.querySelector('[type="submit"]');
      if (hiddenId) hiddenId.value = sel.value;
      if (atbBtn) {
        var opt = sel.options[sel.selectedIndex];
        atbBtn.disabled   = !!opt.disabled;
        atbBtn.textContent = opt.disabled ? 'Sold Out' : 'Add to Cart';
      }
    });

    /* Cart-icon open button */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dy-open-cart]')) openFromIcon();
    });

    /* Initialise cart page cross-sell if we're on /cart */
    initCartPage();
  }

  /* ── Add to cart then open drawer ──────────────────────── */
  function addToCartAndOpen(variantId, qty, submitBtn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function (lineItem) {
      return fetchCart().then(function (cart) {
        renderDrawer(lineItem, cart);
        openDrawer();
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
      });
    })
    .catch(function (err) {
      console.error('[dy-cart]', err);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
    });
  }

  /* Open drawer from cart icon (show current cart state) */
  function openFromIcon() {
    fetchCart().then(function (cart) {
      if (cart.item_count > 0) {
        renderAddedItem(cart.items[cart.items.length - 1]);
      } else if (_addedEl) {
        _addedEl.innerHTML = '<p style="font-family:var(--dy-font-body,sans-serif);font-size:13px;color:#7A5C44;padding:6px 0 2px;">Your cart is empty.</p>';
      }
      updateSubtotal(cart);
      updateCartCount(cart.item_count);
      if (_meetEl) renderMeet(getCartHandles(cart), _meetEl, 'drawer');
      openDrawer();
    });
  }

  /* ── Render drawer ──────────────────────────────────────── */
  function renderDrawer(lineItem, cart) {
    renderAddedItem(lineItem);
    updateSubtotal(cart);
    updateCartCount(cart.item_count);
    if (_meetEl) renderMeet(getCartHandles(cart), _meetEl, 'drawer');
  }

  function renderAddedItem(item) {
    if (!_addedEl) return;
    var imgSrc = '';
    if (typeof item.image === 'string') imgSrc = item.image;
    else if (item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;
    /* Ask Shopify CDN for a smaller version */
    if (imgSrc) {
      imgSrc = imgSrc.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_200x$1$3');
    }
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="dy-cd__item-variant">' + esc(item.variant_title) + '</p>'
      : '';
    _addedEl.innerHTML =
      '<div class="dy-cd__item">'
      + (imgSrc ? '<img class="dy-cd__item-img" src="' + esc(imgSrc) + '" alt="' + esc(item.product_title || item.title) + '" width="88" height="88">' : '<div class="dy-cd__item-img"></div>')
      + '<div class="dy-cd__item-info">'
        + '<p class="dy-cd__item-name">' + esc(item.product_title || item.title) + '</p>'
        + variantLine
        + '<p class="dy-cd__item-qty">Qty: ' + esc(String(item.quantity)) + '</p>'
        + '<p class="dy-cd__item-cost">' + fmtMoney(item.final_line_price) + '</p>'
      + '</div>'
      + '</div>';
  }

  /* ── Cross-sell renderer — shared by drawer + cart page ── */
  function renderMeet(cartHandles, container, context) {
    var toShow = DY_HANDLES.filter(function (h) { return cartHandles.indexOf(h) === -1; });

    if (!toShow.length) {
      container.innerHTML = '<p class="dy-cd__cs-all">Your ritual is complete — all three flavors are in your cart.</p>';
      return;
    }

    container.innerHTML = '<p style="font-family:var(--dy-font-body,sans-serif);font-size:12px;color:#7A5C44;">Loading…</p>';

    Promise.all(toShow.map(fetchProduct)).then(function (products) {
      var cards = products.filter(Boolean).map(function (p) {
        /* Find first available variant */
        var v = null;
        if (p.variants) {
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) { v = p.variants[i]; break; }
          }
        }
        if (!v) return ''; /* sold out — skip */

        var img = (p.images && p.images[0]) ? p.images[0].src : '';
        if (img) img = img.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_200x$1$3');

        return '<div class="dy-cd__cs-card">'
          + (img ? '<img class="dy-cd__cs-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" width="72" height="72" loading="lazy">' : '<div class="dy-cd__cs-img"></div>')
          + '<div class="dy-cd__cs-info">'
            + '<p class="dy-cd__cs-name">' + esc(p.title) + '</p>'
            + '<p class="dy-cd__cs-cost">' + fmtMoney(v.price) + '</p>'
          + '</div>'
          + '<button class="dy-cd__cs-add" type="button" data-dy-quick-add="' + v.id + '" data-dy-handle="' + esc(p.handle) + '">+ ADD</button>'
          + '</div>';
      }).filter(Boolean);

      container.innerHTML = cards.length
        ? cards.join('')
        : '<p class="dy-cd__cs-all">All remaining flavors are sold out right now.</p>';
    }).catch(function () {
      container.innerHTML = '';
    });
  }

  /* ── Cart page init ─────────────────────────────────────── */
  function initCartPage() {
    var cpEl = document.getElementById('dy-cp-meet-products');
    if (!cpEl) return;
    fetchCart().then(function (cart) {
      updateCartCount(cart.item_count);
      renderMeet(getCartHandles(cart), cpEl, 'cart');
    });
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function fetchProduct(handle) {
    if (_productCache[handle]) return Promise.resolve(_productCache[handle]);
    /* Use pre-populated Liquid data if available (no extra request) */
    var preloaded = window.DYProducts && window.DYProducts[handle];
    if (preloaded && preloaded.id) {
      _productCache[handle] = preloaded;
      return Promise.resolve(preloaded);
    }
    /* Fallback: fetch from Shopify AJAX API */
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { _productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function getCartHandles(cart) {
    return (cart.items || []).map(function (i) { return i.handle; });
  }

  function updateSubtotal(cart) {
    if (_subtotalEl) _subtotalEl.textContent = fmtMoney(cart.total_price);
  }

  function updateCartCount(count) {
    var badge = document.getElementById('dy-cart-count');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.hidden = false;
    } else {
      badge.textContent = '';
      badge.hidden = true;
    }
  }

  function openDrawer() {
    if (!_drawer) return;
    _drawer.classList.add('is-open');
    if (_overlay) _overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    _drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    if (!_drawer) return;
    _drawer.classList.remove('is-open');
    if (_overlay) _overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    _drawer.setAttribute('aria-hidden', 'true');
  }

  function fmtMoney(cents) {
    if (cents == null) return '';
    var n = cents / 100;
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function esc(str) {
    if (!str && str !== 0) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Bootstrap ──────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Public API */
  window.DYCartDrawer = { open: openDrawer, close: closeDrawer, openFromIcon: openFromIcon };
})();
